import Launch16 from '@carbon/icons-react/es/launch/16';
import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';

const Title = styled.div`
  color: gray;
  margin: 12px 0px 8px 0px;
`;

const Content = styled.div`
  display: flex;
`;

const Link = styled.a`
  display: flex;
  gap: var(--spacing-02);
`;

const Type = styled.div`
  margin-right: var(--spacing-05);
`;

export const SalesforceConnectedObject: FC<{
  object?: string;
  name?: string;
  url?: string;
}> = ({ object, name, url }) => {
  const linedTitle = useTranslation(
    'project.overview.linked_salesforce_object',
  );

  return (
    <div>
      <Title>{linedTitle}</Title>
      <Content>
        <Type>{object}:</Type>
        <Link href={url} target="_blank" rel="noreferrer">
          {name} <Launch16 />
        </Link>
      </Content>
    </div>
  );
};
